module.exports = __webpack_public_path__ + "img/img95.4424d1f4.jpg";